import { NetworkUtil } from "@/app/network/NetworkUtil.ts";
import { BASIC_CONSTANTS_NETWORK } from "@/app/network/models/NetworkConstants.ts";
import { ApiResponseBody } from "@/app/network/models/ApiResponse.ts";
import { ReferralSummaryDto, ReferredUserDto } from "@/app/core/ProfileComp/referal/types";
import { SingletonClass } from "@/app/utils/SingletonClass.ts";

export class ReferralService extends SingletonClass {
    private static _instance: ReferralService;
    private network = new NetworkUtil();

    static getInstance(): ReferralService {
        if (!ReferralService._instance) {
            ReferralService._instance = new ReferralService();
        }
        return ReferralService._instance;
    }

    /**
     * Получает сводку реферальной программы:
     * ссылку, количество приглашённых, % скидки и статус «пришёл ли сам по рефералке».
     */
    getSummary(): Promise<ApiResponseBody<ReferralSummaryDto>> {
        return this.network.get<ApiResponseBody<ReferralSummaryDto>>(
            BASIC_CONSTANTS_NETWORK.REFERRAL.SUMMARY
        );
    }

    /**
     * Получает список пользователей, зарегистрировавшихся по реферальной ссылке.
     */
    getReferredUsers(): Promise<ApiResponseBody<ReferredUserDto[]>> {
        return this.network.get<ApiResponseBody<ReferredUserDto[]>>(
            BASIC_CONSTANTS_NETWORK.REFERRAL.REFERRED_USERS
        );
    }
}
